import { PlaceApiPlaceUpdateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const usePlaceUpdateMutation = () =>
  useBaseMutation({
    mutationFn: (req: PlaceApiPlaceUpdateRequest, config) =>
      appApiClient.placeApi.placeUpdate(req, config),
  });
